/* istanbul ignore file */

import { environment } from '../../../environments/environment';

export const EmailHelper = {
    isInternalUser(email: string): boolean {
        const domain = email.split('@')[1]?.toLowerCase();
        if (!domain) {
            return false;
        }
        return environment.internalUserDomains.includes(domain);
    },

    getDomain(email: string): string {
        return email.split('@')[1];
    }
};
